export default "__VITE_ASSET__BsG5rS0j__";